function initFormLogic(shadow) {
    const countryBtn  = shadow.querySelector('button[aria-controls="custom#country-selector-dropdown"]');
    const stateBtn    = shadow.querySelector('button[aria-controls="custom#state-selector-dropdown"]');
    const provinceBtn = shadow.querySelector('button[aria-controls="custom#province-selector-dropdown"]');
  
    if (!countryBtn || !stateBtn || !provinceBtn) return;
  
    const getSelectedText = (btn) =>
      btn?.querySelector("span._selectToggleText_12thd_25")?.innerText.trim();
  
  const handleChange = () => {
    const country = getSelectedText(countryBtn);

    if (country === "United States") {
        stateBtn.closest("div").style.display = "block";
        provinceBtn.closest("div").style.display = "none";
      } else if (country === "Canada" || country === 'canada') {
        provinceBtn.closest("div").style.display = "block";
        stateBtn.closest("div").style.display = "none";
      } else {
        stateBtn.closest("div").style.display = "none";
        provinceBtn.closest("div").style.display = "none";
      }
    };
    // First run
    handleChange();
  
    // Instead of click + setTimeout → observe changes to the text span
    const countryTextEl = countryBtn.querySelector("span._selectToggleText_12thd_25");
  
    if (countryTextEl) {
      const countryObserver = new MutationObserver(handleChange);
      countryObserver.observe(countryTextEl, {
        characterData: true,
        childList: true,
        subtree: true
      });
    }
  }
  
  // Observer to wait until form loads inside shadow DOM
  const observer = new MutationObserver((mutations, obs) => {
    const formRoot = document.querySelector("form-embed#app-embed");
    if (!formRoot) return;
    const shadow = formRoot.shadowRoot;
    if (!shadow) return;
  
    const countryEl  = shadow.querySelector('button[aria-controls="custom#country-selector-dropdown"]');
    const stateEl    = shadow.querySelector('button[aria-controls="custom#state-selector-dropdown"]');
    const provinceEl = shadow.querySelector('button[aria-controls="custom#province-selector-dropdown"]');
  
    if (countryEl && stateEl && provinceEl) {
      initFormLogic(shadow);
      obs.disconnect(); // stop once initialized
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });